
import styled from 'styled-components'
import logo from '../../images/logo.png'

const Container = styled.div`
  display: flex;
  align-items: center;
`
const Image = styled.img`
  border-radius: 100px;
  margin-right: 20px;
  height: 40px;
  width: 40px;
`
const Title = styled.h2`
  font-size: 24px;
  margin: 0;
`

export default function Logo() {
  return (
    <Container>
      <Image src={logo} alt="GDark Logo" />
      <Title>GDark</Title>
    </Container>
  )
}
